import DraftEmailContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DraftEmailContent";
import MCBlock from "../../../../../lib/html5-software-library/src/ranj/eng/content/MCBlock";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import EmailItem from "./EmailItem";

export default class EmailDraftItem extends EmailItem {
    
    /**
    * @constructor
    * @param {DraftEmailContent} content 
    * @param {boolean} isRead 
    * @param {boolean} isSent 
    */
    constructor(content, isRead = false, isSent = false) {
        super(content, isRead);

        this.isSent = isSent;
    }

    isCompleted() {
        var incomplete = this.content.getContentBlocks().find(block => block instanceof MCBlock && block.getSelectedOption() == null);
        return incomplete == null;
    }

    send() {
        this.isSent = true;
    }

    toObject() {
        return {
            content: this.content.convertToObject(),
            isRead: this.isRead,
            isSent: this.isSent,
        };
    }

    fromObject(obj, languagePack) {
        if (obj.content) {
            const content = new DraftEmailContent(languagePack);
            content.setPropertiesFromObject(obj.content);

            this.content = content;
        }
        this.isRead = obj.isRead;
        this.isSent = obj.isSent;

        return this;
    }
}